import Grid from '@mui/material/Grid';
import type { StrandedIntakeContent } from '@/components/HighlightMediaText/EligibilityCheckForm/EligibilityCheckForm';
import type { HighlightMediaTextProps } from '@/components/HighlightMediaText/HighlightMediaTextFull/HighlightMediaTextFull';
import TextContent from '@/components/HighlightMediaText/TextContent/TextContent';
import ArtDirectedImage from '@/components/Image/ArtDirectedImage';
import GridContainer from '@/components/Layout/GridContainer/GridContainer';
import { SpacingContainer } from '@/components/SpacingContainer/SpacingContainer';
import VimeoVideo from '@/components/VimeoVideo/VimeoVideo';
import type { FeaturedComponent } from '@/contentful/contentful-exports';
import { MobileOrientation } from '../HighlightMediaText';
import useStyles from './HighlightMediaTextFiftyFifty.styles';

const HighlightMediaTextFiftyFifty = ({
  imageSources,
  mobileImageAspectRatio,
  mobileOrientation,
  video,
  isOnDark,
  isRightAligned,
  subhead,
  cta,
  features,
  isHeroMode,
  eyebrow,
  headline,
  isFeatured,
  imageAltText,
  appLinks,
  intake,
  ...props
}: FeaturedComponent<
  HighlightMediaTextProps & { intake?: StrandedIntakeContent }
>) => {
  const { classes, cx } = useStyles({ isOnDark, mobileImageAspectRatio });

  const videoFields = video?.fields;

  return (
    <SpacingContainer className={classes.container} isFeatured={isFeatured}>
      <GridContainer
        fixed
        gridProps={{
          className: cx(classes.wrapper, {
            invert: !isRightAligned,
            invertOnMobile: mobileOrientation === MobileOrientation.TEXT_FIRST,
          }),
        }}
      >
        <Grid
          size={{
            lg: 7,
            md: 8,
            sm: 12,
            xs: 12,
          }}
        >
          <div className={classes.mediaContainer}>
            {video && videoFields?.videoUrl ? (
              <VimeoVideo
                url={videoFields.videoUrl}
                thumbnailSources={imageSources}
                autoplay={videoFields.autoPlay}
                controls={!videoFields.autoPlay}
                isRounded
              />
            ) : (
              imageSources && (
                <ArtDirectedImage
                  images={imageSources}
                  alt={imageAltText || ''}
                  className={classes.halfImage}
                />
              )
            )}
          </div>
        </Grid>
        <TextContent
          subhead={subhead}
          features={features}
          cta={cta}
          isHeroMode={isHeroMode}
          eyebrow={eyebrow}
          headline={headline}
          isOnDark={isOnDark}
          appLinks={appLinks}
          intake={intake}
          gridSizes={{ lg: 6, md: 6, sm: 12, xs: 12 }}
          {...props}
        />
      </GridContainer>
    </SpacingContainer>
  );
};

export default HighlightMediaTextFiftyFifty;
